import {configureStore} from '@reduxjs/toolkit';
import ThemeOptions from './reducers/ThemeOptions'
import AuthReducer from './reducers/AuthReducer'
import UserReducer from './reducers/UserReducer'
import DashboardsReducer from './reducers/DashboardsReducer'
import PropertyReducer from './reducers/PropertyReducer'
import ProjectReducer from './reducers/ProjectReducer'
import RequirementReducer from './reducers/RequirementReducer'
import ServiceReducer from './reducers/ServiceReducer'
import PropertyVerificationReducer from './reducers/PropertyVerificationReducer'
import ProjectVerificationReducer from './reducers/ProjectVerificationReducer'
import ServiceVerificationReducer from './reducers/ServiceVerificationReducer'
import VerifyTagReducer from './reducers/VerifyTagReducer'
import ActivityLogReducer from './reducers/ActivityLogReducer'
import AppUsersReducer from './reducers/AppUsersReducer'
import PaidSubscriberReducer from './reducers/PaidSubscriberReducer'
import SubAdminReducer from './reducers/SubAdminReducer'
import AdvertisementsReducer from './reducers/AdvertisementsReducer'
import AmenitiesPropertyReducer from './reducers/AmenitiesPropertyReducer'
import AmenitiesProjectReducer from './reducers/AmenitiesProjectReducer'
import AttachmentsInPGReducer from './reducers/AttachmentsInPGReducer'
import GreetingsReducer from './reducers/GreetingsReducer'
import DocumentTypesReducer from './reducers/DocumentTypesReducer'
import ImagesLabelsReducer from './reducers/ImagesLabelsReducer'
import PackagesReducer from './reducers/PackagesReducer'
import ServicesCategoryReducer from './reducers/ServicesCategoryReducer'
import MapIconsReducer from './reducers/MapIconsReducer'
import TenantPreferenceReducer from './reducers/TenantPreferenceReducer'
import ImagesLabelsPropertyReducer from './reducers/ImagesLabelsPropertyReducer'
import ImagesLabelsProjectReducer from './reducers/ImagesLabelsProjectReducer'
import LandmarkReducer from './reducers/LandmarkReducer'
import AdminHistoryReducer from './reducers/AdminHistoryReducer'
import MyRightsReducer from './reducers/MyRightsReducer'
import AddPropertyDataReducer from './reducers/Add/AddPropertyDataReducer'
import AddProjectDataReducer from './reducers/Add/AddProjectDataReducer'
import AddRequirementDataReducer from './reducers/Add/AddRequirementDataReducer'
import AddServiceDataReducer from './reducers/Add/AddServiceDataReducer'
import AddVerifyTagDataReducer from './reducers/Add/AddVerifyTagDataReducer'
import AreaReducer from './reducers/AreaReducer'
import BannerReducer from './reducers/BannerReducer'
import UpdatedStatusReducer from './reducers/UpdatedStatusReducer'

const store = configureStore({
    reducer: {
        auth : AuthReducer,
        ThemeOptions: ThemeOptions,
        UserReducer: UserReducer,
        DashboardsReducer: DashboardsReducer,
        PropertyReducer: PropertyReducer,
        ProjectReducer: ProjectReducer,
        RequirementReducer: RequirementReducer,
        ServiceReducer: ServiceReducer,
        PropertyVerificationReducer: PropertyVerificationReducer,
        ProjectVerificationReducer: ProjectVerificationReducer,
        ServiceVerificationReducer: ServiceVerificationReducer,
        VerifyTagReducer: VerifyTagReducer,
        ActivityLogReducer: ActivityLogReducer,
        AppUsersReducer: AppUsersReducer,
        PaidSubscriberReducer: PaidSubscriberReducer,
        SubAdminReducer: SubAdminReducer,
        AdvertisementsReducer: AdvertisementsReducer,
        AmenitiesPropertyReducer: AmenitiesPropertyReducer,
        AmenitiesProjectReducer: AmenitiesProjectReducer,
        AttachmentsInPGReducer: AttachmentsInPGReducer,
        GreetingsReducer: GreetingsReducer,
        DocumentTypesReducer: DocumentTypesReducer,
        ImagesLabelsReducer: ImagesLabelsReducer,
        PackagesReducer: PackagesReducer,
        ServicesCategoryReducer: ServicesCategoryReducer,
        MapIconsReducer: MapIconsReducer,
        TenantPreferenceReducer: TenantPreferenceReducer,
        ImagesLabelsPropertyReducer: ImagesLabelsPropertyReducer,
        ImagesLabelsProjectReducer: ImagesLabelsProjectReducer,
        LandmarkReducer: LandmarkReducer,
        AdminHistoryReducer: AdminHistoryReducer,
        MyRightsReducer: MyRightsReducer,
        AddPropertyData: AddPropertyDataReducer,
        AddProjectData: AddProjectDataReducer,
        AddRequirementData: AddRequirementDataReducer,
        AddServiceData: AddServiceDataReducer,
        AddVerifyTagData: AddVerifyTagDataReducer,
        AreaReducer: AreaReducer,
        BannerReducer: BannerReducer,
        UpdatedStatusReducer: UpdatedStatusReducer
    }
});


export default store;